import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as layoutActions from 'Global/Stores/layout'
import * as previewModalActions from 'Global/Stores/previewModal'
import * as rugsAsyncActions from 'Global/Stores/rugs'
import * as selectors from './selectors'

const module = 'markedForDesigners'

const layoutToggle = layoutActions.makeLayoutToggle(module)
const limitToggle = layoutActions.makeLimitToggle(module)
const pageSet = layoutActions.makePageSet(module)
const previewModalToggle = previewModalActions.makePreviewModalToggle(module)
const sortBySet = layoutActions.makeSortBySet(module)
const sortOrderToggle = layoutActions.makeSortOrderToggle(module)

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    allRugs: selectors.filterRugs(state),
    filteredRugs: selectors.slicedFilteredRugs(state),
    layout: selectors.layout(state),
    limit: selectors.limit(state),
    pagination: selectors.calculatePagination(state),
    previewOpen: selectors.previewOpen(state),
    rugsDone: selectors.rugsDone(state),
    rugsError: selectors.rugsError(state),
    rugsPending: selectors.rugsPending(state),
    sortBy: selectors.sortBy(state),
    sortOrder: selectors.sortOrder(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    exportToExcel: rugs => dispatch(rugsAsyncActions.rugsExportExcel(rugs)),
    getRugs: () => dispatch(rugsAsyncActions.rugsGet()),
    setPage: page => dispatch(pageSet(page)),
    setSortBy: column => dispatch(sortBySet(column)),
    toggleLayout: () => dispatch(layoutToggle()),
    toggleLimit: () => dispatch(limitToggle()),
    togglePreview: () => dispatch(previewModalToggle()),
    toggleSortOrder: () => dispatch(sortOrderToggle()),
  })

  Enhancer.displayName = 'MarkedForDesignersModuleEnhancer'

  Enhancer.propTypes = {
    allRugs: PropTypes.array.isRequired,
    exportToExcel: PropTypes.func.isRequired,
    filteredRugs: PropTypes.array.isRequired,
    getRugs: PropTypes.func.isRequired,
    layout: PropTypes.string.isRequired,
    limit: PropTypes.number.isRequired,
    pagination: PropTypes.object.isRequired,
    previewOpen: PropTypes.bool.isRequired,
    rugsDone: PropTypes.bool.isRequired,
    rugsError: PropTypes.bool.isRequired,
    rugsPending: PropTypes.bool.isRequired,
    setPage: PropTypes.func.isRequired,
    setSortBy: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
    toggleLayout: PropTypes.func.isRequired,
    toggleLimit: PropTypes.func.isRequired,
    togglePreview: PropTypes.func.isRequired,
    toggleSortOrder: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
